/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { HotkeysService ,Hotkey } from 'angular2-hotkeys';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService, private seoService: SeoService, private hotkeysService: HotkeysService) {
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.hotkeysService.add(new Hotkey('ctrl+b', (event: KeyboardEvent): boolean => {
      // Handle the hotkey action 
      //https://www.npmjs.com/package/angular2-hotkeys/v/13.3.0
      //Referred from the above Website.
      console.log('Hotkey triggered: ctrl+b');
      const lpaPrint = document.getElementById('Print');
      lpaPrint.click(); //Print label for the first Row in the Grid.
      return false; // Prevent default browser behavior
    }));
  }
}
